import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-multiselector-dropdown-brand',
  templateUrl: './multiselector-dropdown-brand.component.html',
  styleUrls: ['./multiselector-dropdown-brand.component.css']
})
export class MultiselectorDropdownBrandComponent implements OnInit {

  @Input() list: any[];
  @Input() index: number;
  showDropDown = false;
  clicked = false;
  @Output() shareBrandCheckedList = new EventEmitter<any>();
  checkedList: any[];
  checkedListName: any[];
  currentSelected: {};

  constructor() {
    this.checkedList = [];
    this.checkedListName = [];
  }

  ngOnInit(): void {
    // This is intentional
  }
  ngOnChanges(_changes: any) {
    if (this.list) {
      let cnt = 1;
      this.checkedList = [];
      this.checkedListName = [];
      this.list.forEach(element => {
        if (element.checked && element.id > 0) {
          cnt++;
          this.checkedList.push(element);
          this.checkedListName.push(element.brandCode);
        }
      });
      if (this.list.length === cnt) {
        this.checkedListName = [];
        this.list[0].checked = true;
        this.checkedListName.push(this.list[0].brandCode);
      }

    }
  }

  getSelectedValue(item: any) {
    if (item.checked) {
      //if status true and selected All
      this.checkedItem(item)
    } else {
    this.uncheckedItem(item)
    }
    this.currentSelected = { item };

    //share checked list
    this.shareCheckedlist();
  }
 checkedItem(item: any) {
    if (item.brandCode === 'All') {
      this.checkedList = [];
      this.checkedListName = [];
      this.checkedListName.push(item.brandCode);
      this.list.forEach(element => {
        element.checked = true;
        if (element.id > 0) {
          this.checkedList.push(element);
        }
      });
    } else {
      this.checkedList.push(item);
      if (this.list.length - 1 === this.checkedList.length) {
        this.checkedListName = [this.list[0].brandCode];
        this.list[0].checked = true;
      } else {
        this.checkedListName.push(item.brandCode);
      }
    }
  }
  uncheckedItem(item: any) {
    if (item.brandCode === 'All') {
      this.checkedList = [];
      this.checkedListName = [];
      this.list.forEach(element => {
        element.checked = false;
      });
    } else {
      const index = this.checkedList.indexOf(item);
      this.checkedList.splice(index, 1);
      if (this.checkedList.length < this.list.length) {
        this.list[0].checked = false;
      }
      this.checkedListName = this.checkedList.map(x => x.brandCode);
    }
  }

  shareCheckedlist() {
    this.shareBrandCheckedList.emit({ checkedList: this.checkedList, index: this.index });
  }

  btnClicked() {
    this.clicked = true;
    this.showDropDown = !this.showDropDown;
  }

}
